import React from 'react';
import { useParams } from 'react-router-dom';
import PostDetail from '../../components/blog/PostDetail';
import { useGetPostBySlug } from '../../hooks/storefront/useGetPostBySlug';
import { useGetRelatedPosts } from '../../hooks/storefront/useGetRelatedPosts';
import { useGetPostCategories } from '../../hooks/storefront/useGetPostCategories';
import { useGetPostTags } from '../../hooks/storefront/useGetPostTags';

const PostDetailPage = () => {
  const { slug } = useParams();
  
  const { post, loading } = useGetPostBySlug(slug);
  const { posts: relatedPosts } = useGetRelatedPosts(slug, { limit: 4 });
  const { categories } = useGetPostCategories();
  const { tags } = useGetPostTags();

  return (
    <PostDetail
      post={post}
      relatedPosts={relatedPosts}
      categories={categories}
      tags={tags}
      loading={loading}
    />
  );
};

export default PostDetailPage;
